export const forbesMockPostLastOpenedStory = async (
    hashId: string,
    signal?: AbortSignal
): Promise<{ hashId: string }> => Promise.resolve({ hashId });
